import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// 1. IMPORT the data structure from the component
import { DownloadData } from './models';
export interface ClientVersionResponse {
  version: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient) { }

  async getClientVersion(client: string): Promise<ClientVersionResponse | boolean> {
    try {
      const res = await firstValueFrom(this.http.get<ClientVersionResponse>(`version/${client}`));
      return res;
    } catch (err) {
      return false;
    }
  }

  // 2. The function promises the DownloadData shape.
  async getClientDownloads(client: string): Promise<DownloadData | boolean> {
    try {
      const res = await firstValueFrom(this.http.get<DownloadData>(`info/downloads/${client}`));
      return res;
    } catch (err) {
      return false;
    }
  }
}
